import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { MessageType } from "../../constants";
export default function HomeFaq({ faqs, setStartChat, setShowFaqs, selectedFaq, selectFAQ, roomToken, setRoomview, miniMize, sendMessage }) {
    const [category, setCategory] = useState({})
    const [activeLink, setActiveLink] = useState("All")
    const [faqList, setFaqList] = useState(faqs)
    const [preview, setpreview] = useState(false)
    // const [selectedFaq, selectFAQ] = useState(selected)
    const settings = {
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        variableWidth: true,
        arrows: true,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 650,
            settings: {

                slidesToShow: 1
            }
        }]


    };
    useEffect(() => {
        let category = {}
        for (let faq of faqs) {
            category[faq.category] = faq.category
        }
        setCategory(category)
    }, [])
    const searchFAQ = (item) => {
        setActiveLink('All')
        let list = faqs.filter((obj) =>
            obj.question &&
                obj.question.toLowerCase().includes(item.toLowerCase().trim())
                ? true
                : false
        );
        setFaqList(list)
    }
    const handleChange = (slide) => {
        if (slide > 0) {
            setpreview(true)
        }
    }
    const handleCategory = (category) => {
        setActiveLink(category)

        if (!category || category === "All") {
            setFaqList(faqs)
        }
        else if (category) {
            let list = faqs.filter((obj) =>
                obj.category &&
                    obj.category === category
                    ? true
                    : false
            );
            setFaqList(list)

        }
    }
    const contactSupport = () => {
        let option = {
            display_value: "chat with an advisor",
            key: "Contact Support",
            type: "selection"
        }
        let json = {
            content: JSON.stringify(option),
            //   refMessageId: messageId,
            type: MessageType.json,
        };
        sendMessage(json);
    }
    return (
        <>
            <div id="container">
                <main>
                    {selectedFaq ?
                        <>
                            <header class="search_header trn sm">
                                <div onClick={() => selectFAQ(null)} class="header-icon"><aside class="heading-text"><span class="backarrow"></span></aside></div>


                                <div class="closeIcon" onClick={() => miniMize()}>✕</div>

                            </header>
                            <div id="allfaqs" className="sm">
                                <div className="fullfaq_article" >

                                    {faqs.map((item) =>
                                        <>{item.question === selectedFaq ?
                                            <div>
                                                <h3>{item.question}</h3>
                                                <p dangerouslySetInnerHTML={{ __html: item.answer }}>

                                                </p>
                                            </div>
                                            : null
                                        }
                                        </>
                                    )}
                                </div>
                                <div className="isquyerSolve">
                                    <div className="qtitle">Did this solve your query</div>
                                    <div className="moreaction">
                                        <button className="btnyes" onClick={() => selectFAQ(null)}>Yes</button>
                                        <button className="btnmore" onClick={() => {
                                            setStartChat(true)
                                            setRoomview(roomToken)
                                            contactSupport()
                                        }}>No, chat with an advisor</button>
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        <>
                            <header class="search_header">
                                <div class="header-icon" onClick={() => setShowFaqs(false)}><aside class="heading-text"><span class="backarrow"></span></aside></div>


                                <div class="closeIcon" onClick={() => miniMize()}>✕</div>
                                <div class="morefaq show active">
                                    <div class="searchbox">
                                        <input type="text" onChange={(event) => searchFAQ(event.target.value)} placeholder="Search your questions" />
                                        <span class="search-icon"></span>
                                    </div>
                                    <div class="faqfilter">
                                        <Slider afterChange={(slide) => handleChange(slide)} className={` `} {...settings} >
                                            <span className={`listItem ${activeLink === "All" ? 'active' : null}`} onClick={() => handleCategory()}>{"All"}</span>
                                            {Object.keys(category).map((item) =>
                                                <span className={`listItem ${activeLink === item ? 'active' : null}`} onClick={() => handleCategory(item)}>{item}</span>
                                            )}
                                        </Slider>
                                        <div class={`${preview ? "pmrevbtn" : null}`}></div>
                                    </div>
                                </div>
                            </header>
                            <div id="allfaqs">
                                <ul class="faq-load">
                                    {faqList.map((item) =>
                                        <li>
                                            <a onClick={() => selectFAQ(item.question)}>{item.question}</a>
                                        </li>
                                    )}

                                </ul>
                                <div class="fullfaq_article">

                                </div>

                            </div>
                        </>}
                </main>
            </div>
        </>
    );
}
